// import { Component, OnInit } from '@angular/core';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdminService } from "../admin.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-cancel-quote',
  templateUrl: './admin-cancel-quote.component.html',
  styleUrls: ['./admin-cancel-quote.component.css']
})
export class AdminCancelQuoteComponent {
  loading = false;
  token = localStorage.getItem("adminToken");

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: AdminService,
    private snackBar: MatSnackBar,
    private router: Router,
  ) { }

  // ngOnInit(): void {
  // }

  cancelQuote(item: any) {
    this.loading = true;
    const cancelQuotePayload = item._id ;
    if (item.trip_status === 'quoteBooked') {
      this.service.cancelQuoteBooked(cancelQuotePayload, this.token).subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.snackBar.open(response.body.message, 'Success', { duration: 5000 });
            location.reload();
          }
          this.loading = false;
        },
        (error: any) => {
          this.loading = false;
          if (['jwt expired', 'jwt malformed'].includes(error.error.message)) {
            this.router.navigateByUrl('/');
            localStorage.clear();
          }
          this.snackBar.open(error.error.message || 'Error cancelling booked quote', 'Fail', { duration: 5000 });
        }
      );
    } else {
      this.service.cancelQuote(cancelQuotePayload, this.token).subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.snackBar.open(response.body.message, 'Success', { duration: 5000 });
            location.reload();
          }
          this.loading = false;
        },
        (error: any) => {
          this.loading = false;
          if (['jwt expired', 'jwt malformed'].includes(error.error.message)) {
            this.router.navigateByUrl('/');
            localStorage.clear();
          }
          this.snackBar.open(error.error.message || 'Error cancelling quote', 'Fail', { duration: 5000 });
        }
      );
    }
  }

}
